import { ReducerAction } from '@keplerco/core';
import { GetUserDto } from '../../../../../models/view/employee';

interface FreemiumManagePersonPermissionsState {
  person: GetUserDto | undefined;
}

export const initialState: FreemiumManagePersonPermissionsState = {
  person: undefined,
};

export enum FreemiumManagePersonPermissionsActionTypes {
  SetPerson = 0,
}

type ManagePersonPermissionsActions = ReducerAction<FreemiumManagePersonPermissionsActionTypes.SetPerson, { payload: GetUserDto | undefined }>;

export function reducer(state: FreemiumManagePersonPermissionsState, action: ManagePersonPermissionsActions): FreemiumManagePersonPermissionsState {
  if (action.type === FreemiumManagePersonPermissionsActionTypes.SetPerson) {
    return { ...state, person: action.payload };
  }
  return state;
}

